import * as React from 'react';
import * as ReactDOM from 'react-dom';
import '../css/grid.css';
import * as $ from "jquery";
import * as globals from './Globals/Globals';
import "jquery-ui";
import Attributes from './Attributes/Attributes'
import GraphTarget from './Layout/LayoutTarget'
import * as aggregation from './GraphComponents/aggregation/countAggregation'
import { DndProvider } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'
import ErrorBoundary from 'react-error-boundary';
import {LogEvents as LogEventsClass} from './Globals/Globals'
import {LOG_EVENT_TYPE_CHART_CREATED, LOG_EVENT_TYPE_CHART_DRAG_ENDED, LOG_EVENT_TYPE_CHART_DRAG_STARTED, LOG_EVENT_TYPE_CHART_DESTROYED, LOG_EVENT_TYPE_CHART_PREDICTION_CLEARED
  ,LOG_EVENT_TYPE_CHART_PREDICTION_ENDED, LOG_EVENT_TYPE_CHART_PREDICTION_STARTED, LOG_EVENT_TYPE_CHART_PREDICTION_PAGE, LOG_EVENT_TYPE_CHART_SEE_DATA_PAGE, LOG_EVENT_TYPE_CHART_BRUSHING_ENDED, 
  LOG_EVENT_TYPE_CHART_BRUSHING_STARTED, LOG_EVENT_TYPE_CHART_BRUSHING_CLICKED, LOG_EVENT_TYPE_CHART_BRUSHING_UNCLICKED, LOG_EVENT_TYPE_CHART_BRUSHING_CLEARED, LOG_EVENT_TYPE_PAGE_REFRESHED} from './Globals/LogConstants'


declare var module: any

export var logEvents

interface AppProps {
    actvity: string;
}

class App extends React.Component<AppProps> {

    constructor(props:any){
        super(props);
      
        aggregation.loadData();
        aggregation.loadCsvData();
        aggregation.loadDataSet()
        this.state = {data :''};
       
    }
    public componentDidMount(){
      document.getElementById('loader').style.display = 'none'

      $(document).ready(function(){
        if(sessionStorage.getItem('record') == 'on')
        {
          document.getElementById('record').style.background = 'green'
          $('#partcipant').val(sessionStorage.getItem('participant'))
          logEvents = JSON.parse(sessionStorage.getItem('logevents'))

          var logevents =  JSON.parse(sessionStorage.getItem('logevents'))
          if(logevents)
          {
            var eventlog = LogEventsClass.addEvent(null, null, null, LOG_EVENT_TYPE_PAGE_REFRESHED , null, null,null,null,null)
            logevents._logEvents.push(eventlog)
            sessionStorage.setItem('logevents', JSON.stringify(logevents))
          }
          
        }
        else
        {
          document.getElementById('record').style.background = 'red'
        }
      });

      $("#record").click(function(){
        if(document.getElementById('record').style.background.includes('red')===true)
        {
          if($('#partcipant').val()=='')
          {
            alert("Participant Name is needed")
          }
          else
          {
            if (confirm("Recording Events for Participant "+ $('#partcipant').val()+" !")) {
              sessionStorage.setItem('record', 'on');
              sessionStorage.setItem('participant', $('#partcipant').val().toString() );
              logEvents = new globals.LogEvents()
              sessionStorage.setItem('logevents', JSON.stringify(logEvents))
              document.getElementById('record').style.background = 'green'
              alert("Recording started")

            } else {
              alert("Recording is not started")
            }
          }
         
         
        }
        else
        {
          alert("Recording is stopped. Now uploading events")
          logEvents = JSON.parse(sessionStorage.getItem('logevents'))
          var data = {
            "participant":sessionStorage.getItem('participant'),
            "researchData":logEvents._logEvents
          }
          sessionStorage.setItem('record', 'off');
          console.log('logevents final',logEvents._logEvents)
          document.getElementById('loader').style.display = 'block'
          fetch("https://nirmalproj.com/PredictVis/logevent", {
            method: "POST",
            body: JSON.stringify(data),
            mode: "cors",
            headers: {
              "Content-Type": "application/json"
            }
          }).then(response => {
            document.getElementById('loader').style.display = 'none'
          })
          document.getElementById('record').style.background = 'red'
        }
     

    });   
    }
    public render() {
        const attributes:any = [];
        const expectations:any = [];
        
        var style = {
            'height':100/globals.dataset.attributes.length+'%'
        }
        var attrNum:number = 0;
        globals.dataset.datasetMap.forEach((value: string, key: string) => attributes.push(
                <Attributes content={value} id={key}   />
          
        ))
      return (
        <ErrorBoundary>
          <DndProvider backend={HTML5Backend}>
          <div className="grid-container">
              <div className="Attributes" id="attributes">
                  {attributes}
                  <input type='text' placeholder="Partcipant Name" id='partcipant'></input>
                  <button id={"record"} style={{background:"red"}}>Record</button>
                  <br></br>
                  Total Records: {globals.dataset.records}
              </div>
          
            <GraphTarget />
          </div>
        
          <div id="loader" ng-hide="data.length > 0"></div>

          </DndProvider>
         </ErrorBoundary>
      );
      
    }
   
}



export default App;
